import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent } from "vue"
import _imports_0 from '@/assets/img/record-text-btn1.png'
import _imports_1 from '@/assets/img/record-text-btn2.png'
import _imports_2 from '@/assets/img/record-pocket-title.png'
import _imports_3 from '@/assets/img/record-pocket1.png'
import _imports_4 from '@/assets/img/record-pocket2.png'
import _imports_5 from '@/assets/img/record-pocket-btn.png'
import _imports_6 from '@/assets/img/record-join-btn.png'


const _hoisted_1 = { class: "record-wrapper" }
const _hoisted_2 = { class: "text-record" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "record-desc" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("已获取“福”字总数")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("个，当前剩余")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("个")
const _hoisted_8 = { class: "btns" }
const _hoisted_9 = {
  key: 1,
  class: "empty"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode("您还没有获得“福”字哦，")
const _hoisted_11 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 快去参与活动写福字抢红包吧。")
const _hoisted_13 = { class: "pocket-record" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "title" }, [
  /*#__PURE__*/_createVNode("img", { src: _imports_2 })
], -1)
const _hoisted_15 = { class: "record-desc" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("已获取的红包总额")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("元")
const _hoisted_18 = {
  key: 0,
  class: "pocket",
  src: _imports_3
}
const _hoisted_19 = {
  key: 1,
  class: "pocket",
  src: _imports_4
}
const _hoisted_20 = { class: "time" }
const _hoisted_21 = {
  key: 2,
  class: "opened"
}
const _hoisted_22 = {
  key: 3,
  class: "btn open",
  src: _imports_5
}
const _hoisted_23 = {
  key: 1,
  class: "empty"
}
const _hoisted_24 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createTextVNode("您还未获得红包 "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" 快去参加活动赢得更多红包吧。")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RandomModal = _resolveComponent("RandomModal")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        (_ctx.textCount.total)
          ? (_openBlock(), _createBlock("div", _hoisted_3, [
              _createVNode("div", _hoisted_4, [
                _hoisted_5,
                _createVNode("span", null, _toDisplayString(_ctx.textCount.total), 1),
                _hoisted_6,
                _createVNode("span", null, _toDisplayString(_ctx.textCount.surplus), 1),
                _hoisted_7
              ]),
              _createVNode("div", _hoisted_8, [
                _createVNode("img", {
                  class: "btn",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goRecordFu && _ctx.goRecordFu(...args))),
                  src: _imports_0
                }),
                _createVNode("img", {
                  class: "btn",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goMarket && _ctx.goMarket(...args))),
                  src: _imports_1
                })
              ])
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_9, [
              _hoisted_10,
              _hoisted_11,
              _hoisted_12
            ]))
      ]),
      _createVNode("div", _hoisted_13, [
        _hoisted_14,
        _createVNode("div", _hoisted_15, [
          _hoisted_16,
          _createVNode("span", null, _toDisplayString(_ctx.amount), 1),
          _hoisted_17
        ]),
        _createVNode("div", {
          class: "list",
          style: _ctx.isLongScreen && 'height:100vw'
        }, [
          (_ctx.list.length)
            ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.list, (item, index) => {
                return (_openBlock(), _createBlock("div", {
                  class: "list-item",
                  key: index,
                  onClick: ($event: any) => (_ctx.openClick(item))
                }, [
                  (item.type == 'none' || item.state == 2)
                    ? (_openBlock(), _createBlock("img", _hoisted_18))
                    : (_openBlock(), _createBlock("img", _hoisted_19)),
                  _createVNode("div", _hoisted_20, _toDisplayString(item.time), 1),
                  (item.type == 'none' || item.state == 2)
                    ? (_openBlock(), _createBlock("div", _hoisted_21, "红包已拆"))
                    : (_openBlock(), _createBlock("img", _hoisted_22))
                ], 8, ["onClick"]))
              }), 128))
            : (_openBlock(), _createBlock("div", _hoisted_23, [
                _createVNode("img", {
                  class: "btn",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.joinClick && _ctx.joinClick(...args))),
                  src: _imports_6
                }),
                _hoisted_24
              ]))
        ], 4)
      ])
    ]),
    (_ctx.showRandomModal)
      ? (_openBlock(), _createBlock(_component_RandomModal, {
          key: 0,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showRandomModal = false)),
          onOpen: _ctx.openRandom,
          randomData: _ctx.modalData
        }, null, 8, ["onOpen", "randomData"]))
      : _createCommentVNode("", true)
  ], 64))
}